import styled from "styled-components";

export const HeaderStyles = styled.div`
  height: 70px;
  padding: 25px 2%;
  width: calc(100% - 240px);
  margin: 0 0 0 auto;
  position: fixed;
  background: #ffff;
  z-index: 999;
  right: 0;
  left: 0;
  top: 0;
  bottom: unset;
  background-color: #f3f6fb;
  border-bottom: 0.1px solid #959595;

  h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    color: #1a1f36;
    line-height: 23px;
  }

  .icon_box {
    cursor: pointer;
    > svg {
      margin-left: 30px;
    }
    .profile_dropdown {
      position: absolute;
      right: 0;
      height: 100px;
      bottom: -80px;
      border: 0.3px solid #ababab49;
      box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.05);
      border-radius: 3px;
      padding: 16px 16px;
      z-index: 2;
      background: white;
      width: 178px;
    }
  }
  @media (max-width: 700px) {
    padding: 20px 5%;
    width: 100%;
    h2 {
      font-size: 20px;
    }
  }
`;
